import { MDBAlert, MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"

export default class UbicacionFormulario extends React.Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                codigo: '',
                nombre: '',
                nombre_comercial: '',
                direccion: '',
                telefono: '',
                no_establecimiento: '',
                padre: '',
                empresa: 0,
                departamento: null,
                municipio: ''
            },
            colapsar: true,
            camposRequeridos: [],
            padres: [],
            empresas: [],
            departamentos: [],
            municipios: []
        };
    }

    componentDidMount() {
        const { registro } = this.state;
        let idDepartamento = null;

        for (const key in registro) {
            if (registro[key] == null) {
                registro[key] = "";
            }
            if (key === 'departamento') {
                idDepartamento = registro[key];
            }
        }

        if(_valid(registro.padre)){
            this.obtenerPadres(registro.empresa);
        }

        this.obtenerPadres()
        this.obtenerEmpresas();
        this.obtenerDepartamentos(idDepartamento);
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    actualizarUbicacion = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
        if(_valid(value)){
            this.obtenerPadres(value);
        }else{
            this.setState({padres: []});
        }
    }

    actualizarValorDepartamento = ({ target: { name, value } }) => {
        this.obtenerMunicipios(value);
    }

    obtenerPadres(id) {
        /*this.apiRest.get('/ubicacion').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ padres: resultado.data });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });*/
        this.apiRest.getUbicacionPorEmpresa('/getUbicacion/'+id).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ padres: resultado.data });
            }
        });
    }

    obtenerEmpresas() {
        this.apiRest.get('/empresa').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ empresas: resultado.data });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    obtenerDepartamentos(idDepartamento) {
        this.apiRest.get('/territorioTipo/DEPARTAMENTO').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentos: resultado.data });
                this.obtenerMunicipios(idDepartamento);
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    obtenerMunicipios(idDepartamento) {
        if (_valid(idDepartamento)) {
            this.apiRest.get('/territorioPadre/' + idDepartamento).then(resultado => {
                if (resultado.exitoso) {
                    this.setState(estadoAnterior => ({
                        municipios: resultado.data,
                        registro: { ...estadoAnterior.registro, departamento: idDepartamento }
                    }));
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    almacenarRegistro = () => {
        if (this.datosRegistroValidos()) {
            const registro = this.state.registro
            if (registro.empresa !== 0) {
                if (registro.id !== undefined && registro.id !== null) {
                    this.apiRest.put('/ubicacion/' + registro.id, registro).then(resultado => {
                        if (resultado.exitoso) {
                            toastr.success('Datos almacenados exitosamente!');
                            this.props.history.replace('/ubicacionListado');
                        } else {
                            toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                        }
                    });
                } else {
                    this.apiRest.post('/ubicacion', registro).then(resultado => {
                        if (resultado.exitoso) {
                            toastr.success('Datos almacenados exitosamente!');
                            this.setState({ registro: resultado.data });
                            this.props.history.replace('/ubicacionListado');
                        } else {
                            toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                        }
                    });
                }
            } else {
                const { camposRequeridos } = this.state;
                //toastr.error('Campo Empresa Esta Vacio');
                this.setState({ camposRequeridos: camposRequeridos });
                setTimeout(() => this.setState({ camposRequeridos: [] }), 3000);
            }
        }
    }

    datosRegistroValidos() {
        const { registro, camposRequeridos } = this.state;
        let contador = 0;
        if (_valid(registro.codigo)) {
            contador +=1;
        }else{
            camposRequeridos.push("Codigo");
        }
        if (_valid(registro.nombre)) {
            contador +=1;
        }else{
            camposRequeridos.push("Nombre");
        }
        if (registro.empresa == '0') {
            camposRequeridos.push("Empresa");
        }else{
            contador +=1;
        }

        this.setState({ camposRequeridos: camposRequeridos });
        setTimeout(() => this.setState({ camposRequeridos: [] }), 3000);

        if(contador === 3){
            return true;
        }else{
            return false;
        }
    }

    render() {
        const { registro, colapsar, camposRequeridos } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Datos" breadcrumbItem="Ubicacion" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Ubicacion</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <div>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label
                                                                        htmlFor="codigo"
                                                                        className="form-label"
                                                                    >
                                                                        Código
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.codigo}
                                                                        onChange={this.actualizarValores}
                                                                        name="codigo"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa el código"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label
                                                                        htmlFor="nombre"
                                                                        className="form-label"
                                                                    >
                                                                        Nombre
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.nombre}
                                                                        onChange={this.actualizarValores}
                                                                        name="nombre"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa el nombre"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label
                                                                        htmlFor="nombre_comercial"
                                                                        className="form-label"
                                                                    >
                                                                        Nombre comercial
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.nombre_comercial}
                                                                        onChange={this.actualizarValores}
                                                                        name="nombre_comercial"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa el nombre comercial"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label
                                                                        htmlFor="direccion"
                                                                        className="form-label"
                                                                    >
                                                                        Dirección
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.direccion}
                                                                        onChange={this.actualizarValores}
                                                                        name="direccion"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa el dirección"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label
                                                                        htmlFor="telefono"
                                                                        className="form-label"
                                                                    >
                                                                        Teléfono
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.telefono}
                                                                        onChange={this.actualizarValores}
                                                                        name="telefono"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresa el teléfono"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label
                                                                        htmlFor="no_establecimiento"
                                                                        className="form-label"
                                                                    >
                                                                        No. Establecimiento
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.no_establecimiento}
                                                                        onChange={this.actualizarValores}
                                                                        name="no_establecimiento"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresa el no. establecimiento"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="nombre" className="form-label">
                                                                        Empresa
                                                                    </Label>
                                                                    <select
                                                                        value={registro.empresa}
                                                                        onChange={this.actualizarUbicacion}
                                                                        name="empresa"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">Seleccionar</option>
                                                                        {this.state.empresas.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="ubicacion" className="form-label">
                                                                        Padre
                                                                    </Label>
                                                                    <select
                                                                        value={registro.padre}
                                                                        onChange={this.actualizarValores}
                                                                        name="padre"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">Seleccionar</option>
                                                                        {this.state.padres.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="nombre" className="form-label">
                                                                        Departamento
                                                                    </Label>
                                                                    <select
                                                                        value={registro.departamento}
                                                                        onChange={this.actualizarValorDepartamento}
                                                                        name="departamento"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">Seleccionar</option>
                                                                        {this.state.departamentos.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="ubicacion" className="form-label">
                                                                        Municipio
                                                                    </Label>
                                                                    <select
                                                                        value={registro.municipio}
                                                                        onChange={this.actualizarValores}
                                                                        name="municipio"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">Seleccionar</option>
                                                                        {this.state.municipios.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    &nbsp;
                                                    <Row>
                                                        {_valid(camposRequeridos) && camposRequeridos.map((campo, index) => <MDBAlert key={index} color="danger"><strong>{campo}</strong> es requerido.</MDBAlert>)}
                                                    </Row>
                                                </Form>
                                            </div>
                                            <Row>
                                                <Col lg={12} className="text-end">
                                                    <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/ubicacionListado') }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect" color="success" onClick={() => this.almacenarRegistro()}>
                                                        <MDBIcon icon="fas fa-user-check" /> {' '}
                                                        Listo
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}